<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" @click.stop="handleClick" class="mb-4 mr-4">
        <v-icon class="mr-2">mdi-transition</v-icon>
        New Conversion
      </v-btn>
    </template>
    <span>
      Initiate a new conversion process to generate a fastq data product from
      this sequencing run
    </span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit('conversion-button')
    },
  },
}
</script>
